
	import {
		Component,
		Vue
	} from "vue-property-decorator";
	import {
		productList
	} from '@/api/supplier'
	import {
		getOssToken
	} from '@/api/user'
	import PageFooter from '@/components/page-footer.vue';
	import UploadImg from '@/components/upload-img.vue';
	import {
		createMaterial,
		updateMaterial,
		materialDetail
	} from '@/api/material'

	@Component({
		name: 'material-info',
		components: {
			PageFooter,
			UploadImg
		}
	})
	export default class MaterialInfo extends Vue {
		private pageType = this.$route.query.type;
		private id = +this.$route.query.id || 0;
		
		private formData:any = {
			Title:'',
			Copywriting: '',
			ImgUrlList: [],
			MaterialType: 0, // 0 图片  1视频
			MaterialCategory: 0, // 1招商 2朋友圈 3商品
			Video: '',
			RelationId: '',
			RelationType: 0
		}
		
		private bindTypes: any = [{
			label: '不关联',
			value: 0
		}, {
			label: '商品关联',
			value: 1
		}];
		private states: any = [{
			label: '招商素材',
			value: 1
		}, {
			label: '发圈素材',
			value: 2
		}, {
			label: '商品素材',
			value: 3
		}]
		private loadingProduct = false;
		private productlst = [];
		private token: any = {};
		private piclist = []

		private mounted() {
			this.getToken();
			if (this.id) {
				this.getDetail();
			}
		}

		private async getToken() {
			try {
				const res: any = await getOssToken({})
				this.token = {
					AccessKeySecret: res.access_key_secret,
					OSSAccessKeyId: res.access_key_id,
					SecurityToken: res.security_token
				}
			} catch (e) {
				console.log('getOssToken ===>', e)
			}
		}

		// 获取素材详情
		private async getDetail() {
			try {
				const res: any = await materialDetail({
					id: +this.id
				});
				
				this.formData = res.Result;
				
			} catch (e) {
				console.log('materialDetail ===> ', e)
			}
		}

		private toBack() {
			this.$router.go(-1)
		}

		// 商品列表
		private async getProductList(query ? : string) {
			if (!query.length) return;
			this.loadingProduct = true;
			const params: any = {
				page_no: 1,
				page_size: 500,
				state: 0
			}
			if (query) {
				params.product_name = query
			}
			try {
				const res: any = await productList(params)
				if (res.info) {
					this.productlst = res.info;
				} else {
					this.productlst = [];
				}
				this.loadingProduct = false;
			} catch (e) {
				this.loadingProduct = false;
				console.log('productList ===>', e)
			}
		}

		// 是否为空
		private isEmpty() {
			if (!this.formData.Title) {
				this.$message('标题不能为空');
				return false;
			}
			if (!this.formData.Copywriting) {
				this.$message('内容不能为空');
				return false;
			}
			if (this.formData.MaterialType===0 && !this.formData.ImgUrlList.length) {
				this.$message('请上传图片');
				return false;
			}
			if (this.formData.MaterialType===1 && !this.formData.Video) {
				this.$message('请上传视频');
				return false;
			}
			return true
		}

		// 提交信息
		private submit() {
			if (!this.isEmpty()) {
				return;
			}
			
			this.doCreate();
		}

		// 创建
		private async doCreate() {
			try {
				await createMaterial(this.formData)
				this.$message({
					type: 'success',
					message: '编辑成功！',
					onClose: () => {}
				})
				this.toBack()
			} catch (e) {
				console.log('createBanner ===>', e)
			}
		}
		
		// 监听图片上传
		private handleUpload(list) {
			if (this.formData.MaterialType) {
				this.formData.Video = list[0]
				this.formData.ImgUrlList = []
			} else {
				this.formData.ImgUrlList = list
				this.formData.Video = ''
			}
		}

		// 素材类型修改
		private changeType() {
			// if (!formData.MaterialType) {
			// 	this.piclist = this.pics
			// } else {
			// 	this.piclist = this.video ? [this.video] : []
			// }
		}
	}
